import { FC } from 'react';
import { useUserStatus } from '../../../config/authentication/useUserStatus';

/**
 * Si showOnLogin es verdadero, se muestra el componente
 * proporcionado cuando está autenticado el usuario.
 * Caso contrario, se muestra el componente cuando no está
 * autenticado.
 */
type Props = {
  children: React.ReactElement;
  showOnLogin?: boolean;
};

export const AuthenticationHOC: FC<Props> = ({ children, showOnLogin }) => {
  const { isLoggedin } = useUserStatus();

  if (isLoggedin === showOnLogin) return children;
  return <></>;
};

AuthenticationHOC.defaultProps = {
  showOnLogin: true,
};
